import {currentResource} from '../../util/utils';

const normalizeItem = ({id: value, name: label, snapshotId}) => ({value, label, snapshotId});

export default (scopes) => {
	const normalized = [];

	currentResource.gaScopesResource.forEach(({id, label}) => {
		if (scopes.some((s) => s.scopeType === id)) {
			normalized.push({
				label,
				options: [
					...scopes.filter(({isSubScope, scopeType}) => !isSubScope && scopeType === id).map(normalizeItem),
					...scopes
						.filter(({isSubScope, scopeType}) => isSubScope && scopeType === id)
						.sort((a, b) => a.name.localeCompare(b.name))
						.map(normalizeItem)
				]
			});
		}
	});

	return normalized;
};
